<h1 mat-dialog-title><strong>Ajout d'une évaluation de groupe</strong></h1>
<form #f="ngForm" (ngSubmit)="submit()">
  <div mat-dialog-content>
    <div class="input-group">
      <mat-form-field>
        <mat-label>Description</mat-label>
        <input
          matInput
          type="text"
          name="description"
          [(ngModel)]="groupAssessmentDescription"
          #description="ngModel"
          [ngClass]="{ 'is-invalid': description.invalid && (description.dirty || description.touched) }"
          required />
        <div class="invalid-feedback">
          @if (description.errors?.['required']) {
          <span>Veuillez saisir une description.</span>
          }
        </div>
      </mat-form-field>
      <syn-assessment-selection (selectAssessments)="addNewAssessment($event)" />
      <syn-date-picker [enable]="enableDate" (date)="onNewDate($event)" />

      @if (enableDate && !isDateInitialized) {
      <div class="text-danger medium mt-1">
        <span>La date d'expiration est obligatoire après avoir sélectionné une évaluation.</span>
      </div>
      }
    </div>
    <div>
      <p>Attention, un email est envoyé à chaque membre du groupe quand vous cliquez sur “Envoyer”</p>
    </div>
  </div>
  @if (send) {
  <div class="spinner-border text-primary ms-2" style="width: 2rem; height: 2rem" role="status">
    <span class="sr-only">Loading...</span>
  </div>
  }
  <mat-dialog-actions class="justify-content-end">
    <button mat-raised-button mat-dialog-close>Annuler</button>
    <button mat-raised-button color="primary" type="submit" [disabled]="f.invalid || !isDateInitialized">
      Envoyer
    </button>
  </mat-dialog-actions>
</form>
